import { SceneView } from "./SceneView"
import { SceneFrame } from "../Components/Scene"

export interface QuickStartSceneViewProps {
  onClose?: () => void;
}

export const quickStartFrames: SceneFrame[] = [
  {
    animations: ["auto-show-overlay"],
    content: "start_quickstart",
    contentOptions: { theme: "dark" },
    name: "start",
    overlayPosition: "hide",
  },
  {
    content: "start_quickstart",
    name: "start",
    overlayPosition: "center",
  },
  {
    content: "start_quickstart",
    contentOptions: { theme: "cloud" },
    name: "start1",
    overlayPosition: "center",
  },
  {
    content: "start_account",
    contentOptions: { theme: "cloud" },
    name: "start2",
    overlayPosition: "center",
  },
  {
    content: "start_account",
    name: "start3",
    overlayPosition: "center",
  },
  {
    content: "create_ship",
    contentOptions: { theme: "cloud" },
    name: "createShip",
    overlayPosition: "bottom-center",
  },
  {
    content: "create_ship_complete",
    name: "createShip2",
    overlayPosition: "bottom-center",
  },
  {
    action: { action: "click", selector: "a[href^=\"logbook://\"]" },
    animations: ["show-action-click"],
    content: "new_ship_selected",
    name: "createShip3",
    overlayPosition: "bottom-center",
  },
  {
    content: "new_ship_app",
    contentOptions: { theme: "dark" },
    name: "createShip4",
    overlayPosition: "bottom-center",
  },
  {
    content: "new_ship_app",
    name: "connectNMEA",
    overlayPosition: "bottom-center",
  },
  {
    content: "new_ship_app",
    name: "connectNMEA2",
    overlayPosition: "bottom-center",
  },
  {
    content: "new_ship_nmea_empty",
    highlight: ".ShipView-menus .Menu-button:has(.ShipView-status-error)",
    name: "connectNMEA3",
    overlayPosition: "bottom-left",
  },
  {
    content: "new_ship_nmea_select",
    name: "connectNMEA4",
    overlayPosition: "bottom-left",
  },
  {
    content: "new_ship_nmea",
    name: "connectNMEA5",
    overlayPosition: "bottom-left",
  },
  {
    action: { action: "click", selector: ".NMEAConfigurationView button.button.default[type=\"submit\"]" },
    animations: ["show-action-click"],
    content: "new_ship_nmea",
    name: "connectNMEA6",
    overlayPosition: "bottom-left",
  },
  {
    content: "new_ship_nmea_test",
    name: "connectNMEA7",
    overlayPosition: "bottom-left",
  },
  {
    action: { action: "click", selector: ".NMEAConfigurationView button.button.default:not([type=\"submit\"])" },
    animations: ["show-action-click"],
    content: "new_ship_nmea_test",
    name: "connectNMEA8",
    overlayPosition: "bottom-left",
  },
  {
    content: "new_ship_ready",
    name: "connectNMEA9",
    overlayPosition: "bottom-center",
  },

  // End screen with buttons to other screencasts
  {
    animations: ["fade-in-content"],
    content: "end",
    name: "final2",
    overlayPosition: "bottom-center",
  },
];

export function QuickStartSceneView({ onClose }: QuickStartSceneViewProps) {
  return <SceneView onClose={onClose} scene="quickstart" frames={quickStartFrames} />;
}
